import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';

/**
    Best with CMS Content Type => Epic Common Share Meta
*/
const MetaTags = ({meta}) => {
    if (!meta) return null;
    const {title, description, image} = meta;
    const tags = [];

    if (title) {
        tags.push(
            {itemProp: 'name', content: title},
            {name: 'twitter:title', content: title},
            {property: 'og:title', content: title}
        );
    }
    
    if (description) {
        tags.push(
            {itemProp: 'description', content: description},
            {name: 'description', content: description},
            {name: 'twitter:description', content: description},
            {property: 'og:description', content: description}
        );
    }

    if (image) {
        tags.push(
            {name: 'twitter:image', content: image},
            {property: 'og:image', content: image}
        )
    }
    
    return (
        <Helmet meta={tags}>
            {title ? <title>{title}</title> : null}
        </Helmet>);
};

MetaTags.propTypes = {
    meta: PropTypes.object
}

export default MetaTags;
